import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState } from 'store';
import { Scaffold } from 'layouts';
import { FormPageHeader } from 'components/Shared';
import { ReasonUpdateForm } from 'components/Pages/CancelationReasons';
import * as S from './styles';

export const CancelationReasonUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const { loading } = useSelector(
    (state: RootState) => state.fetchCancelationReason
  );

  const onUpdate = useCallback((): void => {
    navigate('/configuracoes/justificativas-cancelamento');
  }, [navigate]);

  return (
    <Scaffold>
      <S.PageContainer>
        <S.MainPanel>
          <FormPageHeader
            title="Editar justificativa"
            icon={<S.CancelationIcon />}
            isLoading={loading}
            actions={
              <S.LinkButton
                size="small"
                to="/configuracoes/justificativas-cancelamento"
              >
                <S.ArrowLeftIcon /> Voltar
              </S.LinkButton>
            }
          />
          <ReasonUpdateForm reasonId={id} onUpdate={onUpdate} />
        </S.MainPanel>
      </S.PageContainer>
    </Scaffold>
  );
};
